import {
  Component,
  OnInit,
  AfterViewInit,
  ViewEncapsulation,
  OnChanges,
  AfterContentInit
} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

import { StepsService } from '@shared/services/steps/steps.service';
import { PreOrderService } from '@modules/pre-order/api/pre-order/pre-order.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PanelDetailsService } from '@shared/services/pre-order/panel-details/panel-details.service';
import { PanelOptionsService } from '@shared/services/pre-order/panel-options/panel-options.service';
import { Title } from '@angular/platform-browser';
import { MODULE_NAMES } from '@shared/constants/module-names.ts';
import { SIGNUP_HEADERS } from '@shared/constants/signup-headers.ts';
import { UsersService } from '@shared/api';
@Component({
  selector: 'app-sign-up',
  templateUrl: './pre-order.component.html',
  styleUrls: ['./pre-order.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('200ms', style({ opacity: 0 }))
      ])
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class PreOrderComponent implements OnInit, AfterViewInit {
  transitionDirection;
  headerTexts;
  firstName;
  isCompleted;
  propertyId;
  preOrderDetails;
  progressSteps;
  moduleName;
  MODULE_NAMES = MODULE_NAMES;
  isPreOrder;

  constructor(
    private _stepsService: StepsService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private _preOrderDetails: PreOrderService,
    private _panelDetailsService: PanelDetailsService,
    private _panelOptionsService: PanelOptionsService,
    private _users: UsersService,
    private title: Title
  ) {
    this.moduleName =
      this.activatedRoute.snapshot.data.hasOwnProperty('moduleName') &&
      this.activatedRoute.snapshot.data.moduleName;
    _stepsService.setModuleName(this.moduleName);
    this.isPreOrder = this._stepsService.isCurrentModulePreOrder(
      this.moduleName
    );
    if (!this.moduleName) {
      this.router.navigate(['/app/properties']);
    }
    if (this.moduleName !== MODULE_NAMES.SIGN_UP) {
      this.propertyId =
        this.activatedRoute.snapshot.params.hasOwnProperty('id') &&
        this.activatedRoute.snapshot.params.id;

      !this.propertyId
        ? this.router.navigate(['/app/properties'])
        : this.getPreOrderDetails();
    }
  }

  ngOnInit() {
    this.title.setTitle(
      `Partbnb - ${this.moduleName === 'preorder' ? 'Pre Order' : 'Sign Up'}`
    );
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser || !currentUser.isLogin) {
      this._stepsService.setSession('step_id', 0);
      if (this.isPreOrder) {
        this.router.navigate(['/signup']);
      }
    }
    const currentStep = this._stepsService.getSession('step_id');
    if (!currentStep || currentStep === 0) {
      this._stepsService.setHeaderTexts(SIGNUP_HEADERS.PERSONAL_DETAILS);
      this._stepsService.setDoneSteps([]);
      this._stepsService.setTransitionDirection('RIGHT');
      this._stepsService.setCurrentStep(0);
    } else if (currentStep === 1) {
      this._stepsService.setHeaderTexts(SIGNUP_HEADERS.CONTACT_INFORMATION);
      this._stepsService.setDoneSteps([0]);
      this._stepsService.setTransitionDirection('RIGHT');
      this._stepsService.setCurrentStep(1);
    } else if (currentStep === 2) {
      this._stepsService.setHeaderTexts(
        SIGNUP_HEADERS.CONFIRM_PRE_ORDER_DETAILS
      );
      this._stepsService.setDoneSteps([0, 1]);
      this._stepsService.setTransitionDirection('RIGHT');
      this._stepsService.setCurrentStep(2);
    } else {
      if (!this.propertyId) {
        this.router.navigate(['/']);
        return;
      }
      this._users
        .checkUserForPreOrder(currentUser.username, this.propertyId)
        .subscribe(res => {
          if (res && res.canPreOrder) {
            this._stepsService.setHeaderTexts(
              SIGNUP_HEADERS.CONFIRM_PRE_ORDER_DETAILS
            );
            this._stepsService.setDoneSteps([0, 1]);
            this._stepsService.setTransitionDirection('RIGHT');
            this._stepsService.setCurrentStep(2);
          } else {
            this.router.navigate(['/dashboard']); // navigate to temp dashboard
          }
        });
    }
    this.headerTexts = this._stepsService.getHeaderTexts();
    this.transitionDirection = this._stepsService.getTransitionDirection();
    this.isCompleted = this._stepsService.getSignupCompleted();
    this.progressSteps = this._stepsService.initSteps();

    this._stepsService.updateTransitionDirection.subscribe(direction => {
      this.transitionDirection = direction;
    });
    this._stepsService.updateHeaderTexts.subscribe(text => {
      this.headerTexts.title = text.title;
      if (typeof text.caption === `object`) {
        this.headerTexts.caption = this.isPreOrder
          ? text.caption.preorder
          : text.caption.signup;
      } else {
        this.headerTexts.caption = text.caption;
      }
    });
    if (this.moduleName === MODULE_NAMES.SIGN_UP) {
      this.progressSteps = this.progressSteps.filter(step => step.id !== 2);
    }
  }

  ngAfterViewInit() {
    this.customLogo();
  }

  customLogo() {
    const logoSvg = document.querySelector('#signup-white-logo')
      .firstElementChild;
    let logoAdjustment = logoSvg.innerHTML || '';
    logoAdjustment = logoAdjustment.replace('width="142px"', 'width="138px"');
    logoAdjustment = logoAdjustment.replace('height="36px"', 'height="34px"');
    logoSvg.innerHTML = logoAdjustment;
  }

  getPreOrderDetails() {
    this._preOrderDetails
      .getPreOrderDetails(this.propertyId)
      .subscribe(details => {
        this.preOrderDetails = details;
        this._panelDetailsService.setPreOrderDetails(this.preOrderDetails);
        const {
          pricePerPart,
          partsMaxInvestment,
          partsMinInvestment
        } = details;
        this._panelOptionsService.setPreOrderOptions({
          pricePerPart: pricePerPart,
          partsMaxInvestment: partsMaxInvestment,
          partsMinInvestment: partsMinInvestment
        });
      });
  }

  manageSteps() {
    if (!!this.moduleName && this.moduleName === MODULE_NAMES.SIGN_UP) {
      return true;
    }
    return this.preOrderDetails;
  }
}
